// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import BillingTemplateFormController from "./billing_template_form_controller"
application.register("billing-template-form", BillingTemplateFormController)

import BulkInvoicingController from "./bulk_invoicing_controller"
application.register("bulk-invoicing", BulkInvoicingController)

import ChatRoomController from "./chat_room_controller"
application.register("chat-room", ChatRoomController)

import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FileValidationController from "./file_validation_controller"
application.register("file-validation", FileValidationController)


import InvoiceFormController from "./invoice_form_controller"
application.register("invoice-form", InvoiceFormController)

import JournalFormController from "./journal_form_controller"
application.register("journal-form", JournalFormController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import PaymentFormController from "./payment_form_controller"
application.register("payment-form", PaymentFormController)

import SortableBillingItemsController from "./sortable_billing_items_controller"
application.register("sortable-billing-items", SortableBillingItemsController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TemplateItemFormController from "./template_item_form_controller"
application.register("template-item-form", TemplateItemFormController)

import ReservationModalController from "./reservation_modal_controller"
application.register("reservation-modal", ReservationModalController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import InstallController from "./install_controller"
application.register("install", InstallController)

import BackController from "./back_controller"
application.register("back", BackController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)
